var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLikeFilled = function SvgLikeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.117 7.367A4.699 4.699 0 0 1 16.75 10.9l-5.725 5.725a1.457 1.457 0 0 1-1.033.425c-.375 0-.75-.142-1.034-.425L3.233 10.9a4.7 4.7 0 0 1-1.366-3.533 4.622 4.622 0 0 1 1.708-3.392c1.833-1.517 4.65-1.325 6.408.433H10c1.758-1.758 4.575-1.941 6.408-.433a4.666 4.666 0 0 1 1.709 3.392Z",
    fill: "current"
  })));
};
export default SvgLikeFilled;